export default "__VITE_ASSET__ee046f2c__"